const validate = values => {
  const errors = {}

  if (!values?.calendar) {
    errors.calendar = "The calendar is required"
  }

  if (!values?.subCalendar) {
    errors.subCalendar = "The sub calendar required"
  }

  if (!values?.timezone) {
    errors.timezone = "The timezone is required"
  }

  if (!values?.date) {
    errors.date = "The date is required"
  }

  if (!values?.hour) {
    errors.hour = "The time is required"
  }

  if (!values?.name) {
    errors.name = "The full name is required"
  }

  if (!values?.email) {
    errors.email = "The email is required"
  }

  if (
    values?.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = "A valid email address is required"
  }

  if (!values?.bookedSeats) {
    errors.bookedSeats = "The seats number is required"
  }

  return errors
}

export default validate
